export default __webpack_public_path__ + "static/media/verification-img.4d646fae.png";